<template>
  <div class="page-container">
    <h1 class="page-title">{{ t("pages.products.tape.title") }}</h1>

    <!-- 引言部分 -->
    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          {{ t("pages.products.tape.introduction.title") }}
        </h2>
      </div>
      <div
        class="text-block"
        v-html="renderContent(t('pages.products.tape.introduction.content'))"
      ></div>
      <div class="content-section">
      <div style="text-align: center;">
        <img src="/images/products/带材图.jpg" />
     
      </div>
    </div>
    </div>

    <div class="decorative-divider"></div>

    <!-- 应用案例部分 -->
    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          {{ t("pages.products.tape.introduction.cases[0].title") }}
        </h2>
      </div>
      <div class="model-container">
        <TapeLayerThreeD v-if="is3D" />
      </div>
    </div>
    <div class="decorative-divider"></div>
    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          {{ t("pages.products.tape.introduction.cases[1].title") }}
        </h2>
      </div>
    </div>
    <div class="content-section">
      <div class="spec-wrapper">
        <table v-if="isEnglish" class="spec-table">
          <tbody>
            <tr class="app-header-row">
              <td rowspan="20" class="app-domain-cell" style="width: 100px;">APPLICATIONS</td>
              <td class="app-subtitle-cell">Electrical</td>
              <td class="app-subheader-cell">Width</td>
              <td class="app-subheader-cell">Grades</td>
              <td class="app-subheader-cell">Ic(77K, s.f.)</td>
            </tr>
            <tr>
              <td rowspan="9" class="app-direction-cell">
                <img
                  src="/images/products/强电应用.png"
                  alt="Utility"
                  class="inline-image"
                />
                <span>Utility</span>
              </td>
              <td rowspan="3">3mm</td>
              <td>S</td>
              <td>85-120A</td>
            </tr>
            <tr>
              <td>S+</td>
              <td>120-145A</td>
            </tr>
            <tr>
              <td>SUP</td>
              <td>145-165A</td>
            </tr>
            <tr>
              <td rowspan="3">4mm</td>
              <td>S</td>
              <td>110-160A</td>
            </tr>
            <tr>
              <td>S+</td>
              <td>160-200A</td>
            </tr>
            <tr>
              <td>SUP</td>
              <td>200-250A</td>
            </tr>
            <tr>
              <td rowspan="3">12mm</td>
              <td>S</td>
              <td>360-500A</td>
            </tr>
            <tr>
              <td>S+</td>
              <td>500-600A</td>
            </tr>
            <tr>
              <td>SUP</td>
              <td>600-800A</td>
            </tr>
            <tr class="app-header-row">
              <td class="app-subtitle-cell">Electromagnetic</td>
              <td class="app-subheader-cell">Width</td>
              <td class="app-subheader-cell">Grades</td>
              <td class="app-subheader-cell">Ic(4.2K, 10T)</td>
            </tr>
            <tr>
              <td rowspan="9" class="app-direction-cell">
                <img
                  src="/images/products/高场应用.png"
                  alt="Superconducting magnet"
                  class="inline-image"
                />
                <span>Superconducting magnet</span>
              </td>
              <td rowspan="3">3mm</td>
              <td>S</td>
              <td>260-340A</td>
            </tr>
            <tr>
              <td>S+</td>
              <td>340-490A</td>
            </tr>
            <tr>
              <td>SUP</td>
              <td>490-600A</td>
            </tr>
            <tr>
              <td rowspan="3">4mm</td>
              <td>S</td>
              <td>350-450A</td>
            </tr>
            <tr>
              <td>S+</td>
              <td>450-650A</td>
            </tr>
            <tr>
              <td>SUP</td>
              <td>650-800A</td>
            </tr>
            <tr>
              <td rowspan="3">12mm</td>
              <td>S</td>
              <td>1050-1350A</td>
            </tr>
            <tr>
              <td>S+</td>
              <td>1350-1950A</td>
            </tr>
            <tr>
              <td>SUP</td>
              <td>1950-2400A</td>
            </tr>

            <tr class="section-row">
              <td rowspan="3">CUSTOMIZABLE<br>SPECIFICATIONS</td>
              <td>Substrate</td>
              <td colspan="3">50 μm Hastelloy™ (or 30 μm)</td>
            </tr>
            <tr>
              <td>
                Single piece length<br>
                <span style="font-size:0.85em; font-weight:normal">(without Ic dropout)</span>
              </td>
              <td colspan="3">100m~1000m</td>
            </tr>
            <tr>
              <td class="post-title">Post-processing</td>
              <td colspan="3" class="post-cell">
                <table class="post-subtable">
                  <thead>
                    <tr>
                      <th class="diagonal-cell"></th>
                      <th>Thickness options</th>
                      <th>Total thickness</th>
                      <th>Total width</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowspan="3">Copper plating</td>
                      <td>5 μm*2</td>
                      <td>65 μm</td>
                      <td rowspan="3">3mm, 4mm, 12mm</td>
                    </tr>
                    <tr>
                      <td>10 μm*2</td>
                      <td>75 μm</td>
                    </tr>
                    <tr>
                      <td>20 μm*2</td>
                      <td>95 μm</td>
                    </tr>
                    <tr>
                      <td rowspan="2">Copper lamination</td>
                      <td>75 μm*2</td>
                      <td>230 μm</td>
                      <td rowspan="2">4.8mm, 6mm, 12mm</td>
                    </tr>
                    <tr>
                      <td>150 μm*2</td>
                      <td>380 μm</td>
                    </tr>
                    <tr>
                      <td>SS316 lamination</td>
                      <td>80 μm*2</td>
                      <td>240 μm</td>
                      <td>12mm</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr class="section-row">
              <td>COMMON<br>PROPERTIES</td>
              <td colspan="4" class="post-cell">
                <table class="perf-subtable">
                  <thead>
                    <tr>
                      <th class="diagonal-cell"></th>
                      <th>Copper plating</th>
                      <th>Copper lamination</th>
                      <th>SS316 lamination</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Joint resistance</td>
                      <td colspan="3">20-50 nΩ·cm²</td>
                    </tr>
                    <tr>
                      <td>Tensile strength (77K/MPa)</td>
                      <td>600-700 MPa</td>
                      <td>300-400 MPa</td>
                      <td>&gt;700 MPa</td>
                    </tr>
                    <tr>
                      <td>Min. Bending diameter (mm)</td>
                      <td colspan="2">10</td>
                      <td>15</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <table v-else class="spec-table">
          <!-- <thead>
            <tr>
              <th>应用领域</th>
              <th>应用方向</th>
              <th>超导带宽度</th>
              <th>等级</th>
              <th>Ic</th>
            </tr>
          </thead> -->
          <tbody>
            <tr class="app-header-row">
              <td rowspan="20" class="app-domain-cell">应用领域</td>
              <td class="app-subtitle-cell">强电应用</td>
              <td class="app-subheader-cell">超导带宽度</td>
              <td class="app-subheader-cell">等级</td>
              <td class="app-subheader-cell">Ic(77K, s.f.)</td>
            </tr>
            <tr>
              <td rowspan="9" class="app-direction-cell">
                <img
                  src="/images/products/强电应用.png"
                  alt="强电应用"
                  class="inline-image"
                />
                <span>超导电力</span>
              </td>
              <td rowspan="3">3mm</td>
              <td>常规</td>
              <td>85-120A</td>
            </tr>
            <tr>
              <td>高性能</td>
              <td>120-145A</td>
            </tr>
            <tr>
              <td>超高性能</td>
              <td>145-165A</td>
            </tr>
            <tr>
              <td rowspan="3">4mm</td>
              <td>常规</td>
              <td>110-160A</td>
            </tr>
            <tr>
              <td>高性能</td>
              <td>160-200A</td>
            </tr>
            <tr>
              <td>超高性能</td>
              <td>200-250A</td>
            </tr>
            <tr>
              <td rowspan="3">12mm</td>
              <td>常规</td>
              <td>360-500A</td>
            </tr>
            <tr>
              <td>高性能</td>
              <td>500-600A</td>
            </tr>
            <tr>
              <td>超高性能</td>
              <td>600-800A</td>
            </tr>
            <tr class="app-header-row">
              <td class="app-subtitle-cell">高场应用</td>
              <td class="app-subheader-cell">超导带宽度</td>
              <td class="app-subheader-cell">等级</td>
              <td class="app-subheader-cell">Ic(4.2K, 10T)</td>
            </tr>
            <tr>
              <td rowspan="9" class="app-direction-cell">
                <img
                  src="/images/products/高场应用.png"
                  alt="高场应用"
                  class="inline-image"
                />
                <span>超导磁体</span>
              </td>
              <td rowspan="3">3mm</td>
              <td>常规</td>
              <td>260-340A</td>
            </tr>
            <tr>
              <td>高性能</td>
              <td>340-490A</td>
            </tr>
            <tr>
              <td>超高性能</td>
              <td>490-600A</td>
            </tr>
            <tr>
              <td rowspan="3">4mm</td>
              <td>常规</td>
              <td>350-450A</td>
            </tr>
            <tr>
              <td>高性能</td>
              <td>450-650A</td>
            </tr>
            <tr>
              <td>超高性能</td>
              <td>650-800A</td>
            </tr>
            <tr>
              <td rowspan="3">12mm</td>
              <td>常规</td>
              <td>1050-1350A</td>
            </tr>
            <tr>
              <td>高性能</td>
              <td>1350-1950A</td>
            </tr>
            <tr>
              <td>超高性能</td>
              <td>1950-2400A</td>
            </tr>

            <tr class="section-row">
              <td rowspan="4">可选配参数</td>
              <td>基带厚度/材料</td>
              <td colspan="3">30 μm 哈氏合金</td>
            </tr>
            <tr>
              <td>基带厚度/材料</td>
              <td colspan="3">50 μm 哈氏合金</td>
            </tr>
            <tr>
              <td>单根长度</td>
              <td colspan="3">100m~1000m</td>
            </tr>
            <tr>
              <td class="post-title">后处理</td>
              <td colspan="3" class="post-cell">
                <table class="post-subtable">
                  <thead>
                    <tr>
                      <th class="diagonal-cell"></th>
                      <th>镀铜可选厚度</th>
                      <th>带材总厚度</th>
                      <th>带材总宽度</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowspan="3">镀铜</td>
                      <td>5 μm*2</td>
                      <td>65 μm</td>
                      <td rowspan="3">3mm、4mm、12mm</td>
                    </tr>
                    <tr>
                      <td>10 μm*2</td>
                      <td>75 μm</td>
                    </tr>
                    <tr>
                      <td>20 μm*2</td>
                      <td>95 μm</td>
                    </tr>
                    <tr>
                      <td rowspan="2">紫铜封装</td>
                      <td>75 μm*2</td>
                      <td>230 μm</td>
                      <td rowspan="2">4.8mm、6mm、12mm</td>
                    </tr>
                    <tr>
                      <td>150 μm*2</td>
                      <td>380 μm</td>
                    </tr>
                    <tr>
                      <td>不锈钢封装</td>
                      <td>80 μm*2</td>
                      <td>240 μm</td>
                      <td>12mm</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr class="section-row">
              <td>基本性能</td>
              <td colspan="4" class="post-cell">
                <table class="perf-subtable">
                  <thead>
                    <tr>
                      <th class="diagonal-cell"></th>
                      <th>镀铜</th>
                      <th>紫铜封装</th>
                      <th>不锈钢封装</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>接头电阻率</td>
                      <td colspan="3">20-50 nΩ·cm²</td>
                    </tr>
                    <tr>
                      <td>临界拉应力强度（77K/MPa）</td>
                      <td>600-700 MPa</td>
                      <td>300-400 MPa</td>
                      <td>&gt;700 MPa</td>
                    </tr>
                    <tr>
                      <td>最小转弯直径（mm）</td>
                      <td colspan="2">10</td>
                      <td>15</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="decorative-divider"></div>

    <!-- 产品资质部分 -->
    <div class="content-section">
      <div class="section-header">
        <h2 class="section-title">
          {{ isEnglish ? 'Certifications' : '产品资质' }}
        </h2>
      </div>
      <div style="text-align: center; margin-top: 20px;">
        <img src="/images/products/ISO9001.png" style="max-width: 100%; box-shadow: 0 0 10px rgba(0,0,0,0.05);" />
      </div>
    </div>
    <div class="decorative-divider"></div>

    <!-- FAQ 部分 -->
    <div v-if="isEnglish" class="content-section faq-section">
      <div class="section-header">
        <h2 class="section-title">FAQ</h2>
      </div>
      <div class="faq-container">
        <el-collapse accordion>
          <el-collapse-item v-for="(item, index) in faqItems" :key="index" :name="index">
            <template #title>
              <div class="faq-question">
                <span class="q-prefix">Q:</span>
                <span class="q-text">{{ item.q }}</span>
              </div>
            </template>
            <div class="faq-answer">
              <span class="a-prefix">A:</span>
              <div class="a-text" v-html="item.a"></div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div v-if="isEnglish" class="decorative-divider"></div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useLangStore } from "@/pinia/stores/lang";
import TapeLayerThreeD from "@/components/Products/TapeLayerThreeD.vue";
// import TapeLayerCanvas from '@/components/Products/TapeLayerCanvas.vue';

const { t } = useI18n();
const langStore = useLangStore();
const is3D = ref(true);

// 判断当前是否为英文
const isEnglish = computed(() => !langStore.currentLang.startsWith('zh'));

// 动态获取产品规格图片路径
const productSpecImage = computed(() => 
  isEnglish.value ? '/images/products/产品规格英文.png' : '/images/products/产品规格.png'
);

const handleModeChange = (value: boolean) => {
  console.log(`切换到${value ? "3D" : "2D"}模式`);
};

// FAQ 数据
const faqItems = [
  {
    q: "What type of high-temperature superconductor (HTS) tapes (wires) does SST manufacture?",
    a: "Shanghai Superconducting Technology Co., Ltd (SST) specializes in mass production of REBCO coated conductors (rare-earth barium copper oxide), also known as the 2nd generation high-temperature superconductor tapes (wire)."
  },
  {
    q: "What technology does SST deploy to deposit REBCO layer?",
    a: "SST uses Pulsed Laser Deposition (PLD) to deposit the REBCO layer. PLD is currently the mainstream technology deployed by leading HTS manufacturers worldwide, offering consistent and high-performing HTS tapes (wires) at favorable yield and efficiency."
  },
  {
    q: "What is the current annual production capacity at SST?",
    a: "In 2025, SST has achieved an annual production capacity of 4,000 kilometers of 12mm HTS tape (wire), equivalent to 3GAm/yr performance output. SST is currently scaling up with new phase Ⅲ plant to work towards an annual capacity of 20,000 km 12mm HTS tape (wire)."
  },
  {
    q: "What’s the lead time for an order?",
    a: "Lead time varies dynamically with product specifications, total order volume and the time of order placement. For typical copper-plated tapes, SST can often deliver 10 km within 1 month and 100 km within 2 months. In 2025, more than 90% of orders were delivered on time."
  },
  {
    q: "What HTS tape specifications are offered by SST?",
    a: "SST offers a diverse portfolio of HTS products tailored to various technical specifications and superconducting applications. Customers may choose tapes of different widths, substrates of different thicknesses, stabilizers of different kinds and thicknesses, and so on. For detailed information, please refer to the product brochure <a href='https://www.shsctec.com/zh/products/tape' target='_blank'>https://www.shsctec.com/zh/products/tape</a>, or contact our sales representative: <a href='mailto:sales@shsctec.com'>sales@shsctec.com</a> to discuss your specific needs."
  },
  {
    q: "What are the typical electrical and mechanical properties of SST’s HTS tapes (wires)?",
    a: "Electrical and mechanical properties of HTS products vary widely with its specifications. Please contact our sales representative: <a href='mailto:sales@shsctec.com'>sales@shsctec.com</a> to discuss your specific requirements, and they would be very ready to provide you with relevant data about critical current performances, anisotropy, AC loss and mechanical characteristics such as tensile, compressive and bending."
  },
  {
    q: "What are the leading user cases for SST’s HTS tapes (wires) worldwide?",
    a: "Since 2020, SST has cumulatively supplied more than 7500km HTS tapes (wires) worldwide, primarily to well established HTS applications such as fusion, transmission cable for power grids and superconducting magnets. Meanwhile, as continuous improvement and scaling up at SST empowers the global HTS market with shorter lead time, lower cost and persistent product quality, new applications adopting HTS products by SST are emerging quickly. Such novel applications include shunt reactor, induction heater, resonator, SMES, Maglev train, motor and monocrystalline silicon furnace. Please refer to <a href='https://www.shsctec.com/en/applications' target='_blank'>https://www.shsctec.com/en/applications</a> for leading user cases of SST’s HTS tapes (wires) worldwide."
  },
  {
    q: "What does SST do to ensure the quality and performance of its HTS tapes (wires)?",
    a: "At SST, quality management is our top priority. Throughout our production processes, SST undertakes an exhaustive list of quality assurance measurements to ensure excellence and consistency of our products from batch to batch. Taking long-length critical current characterization as an example, each SST tape (wire) would have been measured 4 times at different stage of its production before it is shipped to our customer. While dimensional and electrical properties are always provided in our standard inspection reports, certain customizable inspections may also be requested in addition, such as mechanical measurements, joint resistance, high field performance and geometrical uniformity. Feel free to contact our sales representative to discuss your needs and enquire what is available from SST: <a href='mailto:sales@shsctec.com'>sales@shsctec.com</a> ."
  },
  {
    q: "How to request for samples from SST for initial evaluation?",
    a: "We are happy to provide free samples to any potential customers. Please contact us: <a href='mailto:sales@shsctec.com'>sales@shsctec.com</a> for discussion on your requirement."
  },
  {
    q: "Does SST provide global shipping and after-sales services for HTS tape (wire)?",
    a: "Absolutely. SST offers free global delivery, beneficial warranty terms and comprehensive after-sales services to its customers worldwide. The HTS tapes (wires) are packaged at SST with professional shock-proof and moisture-proof methods to ensure product integrity during transportation. We work with leading international logistic companies to deliver our products promptly to global customers by air freight. And all products sold by SST are covered by a generous warranty. After sales, the SST sales team are also available at 24/7 to discuss further queries by customers, such as additional technical data provision, answering technical questions at depth, and even guiding how to best handle the tapes for splicing, winding and testing."
  }
];

// 渲染带有换行的内容
const renderContent = (content: string) => {
  if (!content) return "";
  return content
    .split("\n\n")
    .map((paragraph) => `<p>${paragraph}</p>`)
    .join("");
};
</script>

<style scoped>
@import "@/assets/styles/content-blocks.scss";

.model-controls {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.model-container {
  height: 350px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 40px;
}

.detail-section {
  margin-top: 40px;
}

.detail-section h2 {
  color: var(--primary-color);
  margin-top: 30px;
  margin-bottom: 15px;
  font-size: 1.8rem;
}

.detail-section p {
  line-height: 1.6;
  margin-bottom: 20px;
}

.detail-section ul {
  margin-bottom: 30px;
}

.detail-section li {
  margin-bottom: 10px;
}

.page-container {
  max-width: 1200px;
  margin: 0 auto;
}

@media screen and (max-width: 768px) {
  .page-container {
    padding: 30px 15px;
  }
}
.page-container {
  overflow: auto;
}

.spec-wrapper {
  text-align: center;
}

.spec-image {
  max-width: 100%;
}

.spec-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  font-size: 0.9em;
  text-align: center;
  /* border: 1px solid #000; */
  box-shadow: none;
}

.spec-table th, .spec-table td {
  border: 0.8px solid #000;
  padding: 6px 4px;
  vertical-align: middle;
  min-width: 54px;
  line-height: 1.2;
}

.faq-section {
  margin-top: 40px;
  margin-bottom: 60px;
}

.faq-container {
  margin-top: 20px;
  
  :deep(.el-collapse) {
    border: none;
  }

  :deep(.el-collapse-item) {
    margin-bottom: 15px;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    }

    &.is-active {
      border-color: var(--primary-color);
    }
  }

  :deep(.el-collapse-item__header) {
    padding: 15px 20px;
    height: auto;
    line-height: 1.5;
    font-size: 1rem;
    font-weight: 500;
    background-color: #fcfcfc;
    border-bottom: none;

    &.is-active {
      background-color: #fff;
      color: var(--primary-color);
    }
  }

  :deep(.el-collapse-item__wrap) {
    border-bottom: none;
  }

  :deep(.el-collapse-item__content) {
    padding: 15px 20px 20px 20px;
    color: #606266;
    line-height: 1.7;
    font-size: 0.95rem;
  }
}

.faq-question {
  display: flex;
  align-items: flex-start;
  text-align: left;
  
  .q-prefix {
    font-weight: bold;
    color: var(--primary-color);
    margin-right: 10px;
    flex-shrink: 0;
  }
}

.faq-answer {
  display: flex;
  align-items: flex-start;

  .a-prefix {
    font-weight: bold;
    color: #67c23a;
    margin-right: 10px;
    flex-shrink: 0;
  }

  .a-text {
    flex: 1;

    :deep(a) {
      color: var(--primary-color);
      text-decoration: none;
      word-break: break-all;
      
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.spec-table thead th {
  font-weight: bold;
  padding: 6px 4px;
}

.spec-table .section-row td:first-child {

  font-weight: bold;
}

.spec-table .inline-image {
  display: block;
  max-width: 90px;
  margin: 4px auto;
  vertical-align: middle;
}

.spec-table .app-header-row td {
  font-weight: 700;
}

.spec-table .app-domain-cell {
  width: 70px;
  font-weight: 700;
}

.spec-table .app-subtitle-cell {
  width: 92px;
  font-weight: 700;
}

.spec-table .app-subheader-cell {
  font-weight: 700;
}

.spec-table .app-direction-cell span {
  display: block;
}

.spec-table .post-title {
  font-weight: 600;
}

.spec-table .post-cell {
  padding: 0;
}

.post-subtable {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 0.95em;
}

.post-subtable th,
.post-subtable td {
  border: 0.8px solid #000;
  padding: 6px 4px;
  text-align: center;
  vertical-align: middle;
  line-height: 1.3;
}

.post-subtable tr:first-child > * {
  /* border-top: 0; */
}

.post-subtable tr:last-child > * {
  border-bottom: 0;
}

.post-subtable tr > *:first-child {
  border-left: 0;
}

.post-subtable tr > *:last-child {
  border-right: 0;
}

.post-subtable thead th {

  font-weight: 600;
}

.post-subtable .diagonal-cell {
  position: relative;
  padding: 0;
  min-height: 28px;
}

.post-subtable .diagonal-cell::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top right,
    transparent calc(50% - 0.5px),
    #000 50%,
    transparent calc(50% + 0.5px)
  );
  pointer-events: none;
}

.perf-subtable .diagonal-cell {
  position: relative;
  padding: 0;
  min-height: 28px;
}

.perf-subtable .diagonal-cell::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top right,
    transparent calc(50% - 0.5px),
    #000 50%,
    transparent calc(50% + 0.5px)
  );
  pointer-events: none;
}

.perf-subtable {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 0.95em;
}

.perf-subtable th,
.perf-subtable td {
  border: 0.8px solid #000;
  padding: 6px 4px;
  text-align: center;
  vertical-align: middle;
  line-height: 1.3;
}

.perf-subtable tr:first-child > * {
  /* border-top: 0; */
}

.perf-subtable tr:last-child > * {
  border-bottom: 0;
}

.perf-subtable tr > *:first-child {
  border-left: 0;
}

.perf-subtable tr > *:last-child {
  border-right: 0;
}

.perf-subtable thead th {
  font-weight: 600;
}
</style> 
